var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",staticStyle:{"padding":"40px","text-align":"center"}},[_c('p',[_vm._v("「特例车牌」已合并至「捷卫士车辆管理」，正在跳转…")])])}]

export { render, staticRenderFns }